import { CartUpdateEvent, ThemeEvents } from "@theme/events";
import { morphSection } from "@theme/section-renderer";

// Custom code: cart addon

class CartAddonComponent extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  /**
   * Handles the cart update.
   * @param {CartUpdateEvent} event - The event.
   */
  #onCartUpdate = (event) => {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    // CartAddEvent puts sections in event.detail.sections
    // CartUpdateEvent puts sections in event.detail.data.sections
    const sections = event.detail.data?.sections;
    const html = sections?.[sectionId];

    if (!html) return;

    morphSection(sectionId, html);
  };
}

if (!customElements.get("cart-addon-wrapper")) {
  customElements.define("cart-addon-wrapper", CartAddonComponent);
}
